// eslint-disable-next-line max-len

import { Action } from '@ngrx/store';
import { MailMergeQueryParameters } from '@quorum/models/xs-query';
import { MailMerge } from '@quorum/models/xs-resource';

export const GET_MAIL_MERGES_FROM_SERVER = '[SVC] Get Mail Merges From Server';
export class GetMailMergesFromServer implements Action {
  readonly feature = 'svc';
  readonly type = GET_MAIL_MERGES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: MailMergeQueryParameters) {}
}

export const GET_MAIL_MERGES_FROM_SERVER_SUCCESS = '[SVC] Get Mail Merges From Server Success';
export class GetMailMergesFromServerSuccess implements Action {
  readonly feature = 'svc';
  readonly type = GET_MAIL_MERGES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { mailMerges: MailMerge[] }) {}
}

export const GET_MAIL_MERGES_FROM_SERVER_FAILURE = '[SVC] Get Mail Merges From Server Failure';
export class GetMailMergesFromServerFailure implements Action {
  readonly feature = 'svc';
  readonly type = GET_MAIL_MERGES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type MailMergesAction =
  | GetMailMergesFromServer
  | GetMailMergesFromServerSuccess
  | GetMailMergesFromServerFailure;
